import { Box, useMediaQuery } from "@mui/material";
import React from "react";
import { useTheme } from "@emotion/react";
import GradientFramedLayout from "../../../layouts/GradientFramedLayout";

interface SideMenuLayoutProps {
  onboardingStepper: React.ReactNode;
  children: React.ReactNode;
  /** `side`: stepper column beside content (default). `top`: full-width row above content. */
  stepperPlacement?: "side" | "top";
}

const SideMenuLayout: React.FC<SideMenuLayoutProps> = ({
  onboardingStepper,
  children,
  stepperPlacement = "side"
}) => {
  const theme = useTheme();
  //@ts-ignore - Don't want to fix the breakpoints on the theme right now.
  const screenWidthIsMdOrSmaller = useMediaQuery(theme.breakpoints.down("lg"));

  const isTop = stepperPlacement === "top";

  let sideOrTopStepper: React.ReactNode;
  if (isTop) {
    sideOrTopStepper = (
      <Box
        flex="0 0 auto"
        sx={{
          marginBottom: "30px",
          paddingX: { md: 0, xs: 2 },
          width: "100%"
        }}
      >
        {onboardingStepper}
      </Box>
    );
  } else if (screenWidthIsMdOrSmaller) {
    sideOrTopStepper = <Box flex="0">{onboardingStepper}</Box>;
  } else {
    sideOrTopStepper = <Box flex="0 0 370px">{onboardingStepper}</Box>;
  }
  return (
    <GradientFramedLayout showHeader={false}>
      <Box
        sx={{
          boxSizing: "border-box",
          display: "flex",
          flexDirection: isTop ? "column" : "row",
          minHeight: "100vh",
          padding: {
            xs: "30px 0px 60px 0px",
            md: "64px 50px 50px 50px"
          },
          width: "100%"
        }}
      >
        {sideOrTopStepper}
        <Box
          sx={{
            flex: "1",
            display: "flex",
            flexDirection: "column",
            width: "100%"
          }}
        >
          {children}
        </Box>
      </Box>
    </GradientFramedLayout>
  );
};

export default SideMenuLayout;
